/**
 * Determines if a team row is a placeholder (not yet defined).
 * Primary: name starts with "Ganador UEFA "
 * Safety net: falsy flag URL
 *
 * @param {{ name: string, flag: string }} row
 * @returns {boolean}
 */
export const isPlaceholderTeam = (row) =>
  /^Ganador UEFA /.test(row.name) || !row.flag;

/**
 * Builds the URL for country detail, preserving existing query params.
 *
 * @param {string} baseRoute   - Current pathname (e.g. '/mx/mundial2026')
 * @param {string} currentSearch - Current query string (e.g. '?tab=standings')
 * @param {string} countryId   - Country code to set (e.g. 'MEX')
 * @returns {string}
 */
export const buildCountryDetailUrl = (baseRoute, currentSearch, countryId) => {
  const params = new URLSearchParams(currentSearch);
  params.set('countryId', countryId);
  params.set("tab", "countries")
  params.delete("screen")
  return `${baseRoute}?${params.toString()}`;
};
